import { Injectable } from '@angular/core';
import { AppIcons, IIcons } from '@datachain/ui-sdk/components';

export enum ActionIcons {
	Activate = 'action:activate',
	Add = 'action:add',
	AddMember = 'action:add-member',
	ColumnChooser = 'action:column-chooser',
	Copy = 'action:copy',
	Deactivate = 'action:deactivate',
	Delete = 'action:delete',
	Regenerate = 'action:regenerate',
	Remove = 'action:remove',
	RemoveMember = 'action:remove-member',
	RemoveSelection = 'action:remove-selection',
}

@Injectable()
export class AppActionsIcons extends AppIcons {
	private readonly path = './assets/img';
	protected override namespace = 'action';

	protected icons: IIcons = {
		[ActionIcons.Activate]: `${this.path}/common/flash_on_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[ActionIcons.Add]: `${this.path}/common/add_circle_48dp_FILL1_wght400_GRAD0_opsz48.svg`,
		[ActionIcons.AddMember]: `${this.path}/common/member_add_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[ActionIcons.ColumnChooser]: `${this.path}/common/splitscreen_vertical_add_24dp_FILL0_wght0_GRAD0_opsz24.svg`,
		[ActionIcons.Copy]: `${this.path}/common/file_copy_24dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[ActionIcons.Deactivate]: `${this.path}/common/flash_off_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[ActionIcons.Delete]: `${this.path}/common/delete_FILL0_wght400_GRAD0_opsz24.svg`,
		[ActionIcons.Regenerate]: `${this.path}/common/regenerate_48dp_FILL0_wght400_GRAD0_opsz48.svg`,
		[ActionIcons.Remove]: `${this.path}/common/move_item_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[ActionIcons.RemoveMember]: `${this.path}/common/member_remove_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[ActionIcons.RemoveSelection]: `${this.path}/common/remove_selection_48dp_FILL0_wght400_GRAD0_opsz48.svg`,
	};
}
